<template>
  <div class="outside-container">
    <div class="editor-wrapper">
      <div class="editor page-canvas">
        <ToolBar :bus="currentBus"
                 :canvas-state="currentCanvasState"
                 :designLocked="designLocked"
                 v-if="currentBus"></ToolBar>

        <!-- invisible components -->
        <EditorFonts :design="design" @fonts-loaded="onFontsLoaded" @font-load-error="onFontLoadError"></EditorFonts>
        <ImageUploadDropzone :bus="currentBus" @drop-fail="onDropFail" :disabled="designLocked"></ImageUploadDropzone>

        <div class="main-area">

          <b-alert @dismissed="clearMessage" dismissible fade variant="success"
          class="editor-alert" :show="editorMessage ? 5 : 0">{{editorMessage}}
          </b-alert>
          <b-alert dismissible fade variant="warning"
          class="editor-alert" :show="missingFonts.length > 0">Oops! We have more than 70,000 licensed fonts, but we're missing these:<br>{{missingFonts.join(', ')}}
          </b-alert>

          <FieldOptionsArea :bus="currentBus" :canvas-state="currentCanvasState" v-if="currentBus"></FieldOptionsArea>

          <div class="canvas-area">

            <EditorCanvas pageNum="0" :bus="busses[0]" :class="{hide: pageNum != 0}" :fontsLoaded="fontsLoaded" @input="onCanvasState" :designLocked="designLocked" :nofill="nofill"></EditorCanvas>
            <EditorCanvas pageNum="1" :bus="busses[1]" :class="{hide: pageNum != 1}" :fontsLoaded="fontsLoaded" @input="onCanvasState" :designLocked="designLocked" :nofill="nofill"></EditorCanvas>
            <div class="thumbnail-wrapper" v-if="fontsLoaded && showThumbnails">
              <EditorThumbnail class="thumbnail" :class="{active: pageNum == 0}" pageNum="0" />
              <EditorThumbnail class="thumbnail" :class="{active: pageNum == 1}" pageNum="1"  v-if="designPageCount > 1" />
              <EditorBackPlaceholder :bus="currentBus" :locked="lockButtons" v-else />
            </div>
          </div>
        </div>
      </div>
      <SideMenu :bus="currentBus" :actionParams="actionParams" @action="onAction" :canvas-state="currentCanvasState"></SideMenu>
    </div>
    <FixedMenu :actionParams="actionParams" @action="onAction"></FixedMenu>
  </div>
</template>

<!--deliberately not scoped-->
<style>
  /*
  prevents canvas from autoscroll when typing text offscreen:
  https://github.com/fabricjs/fabric.js/issues/2904
  */
  textarea[data-fabric-hiddentextarea]{
    position: fixed !important;
    top:-999px !important;
    left:-999px !important;

    /*font size must be 16px+ or iPhone will try to auto zoom in*/
    font-size:16px !important;

    -webkit-user-modify: read-write-plaintext-only;
    user-modify: read-write-plaintext-only;
  }

  /*want to show the text area to debug? use this instead*/

  /*textarea[data-fabric-hiddentextarea]{*/
    /*position: fixed !important;*/
    /*top:0px !important;*/
    /*left:0px !important;*/
    /*opacity: 1 !important;*/
    /*width:300px !important;*/
    /*height:50px !important;*/
    /*z-index:100 !important;*/
    /*-webkit-user-modify: read-write-plaintext-only;*/
    /*user-modify: read-write-plaintext-only;*/
    /*font-size:16px !important;*/
  /*}*/


</style>

<style scoped lang="scss">
@import '~scss/colors';


.outside-container{
  display:block;
  margin:0 auto;
  background-color: $gray-3;
}

.editor-wrapper{
  display:flex;
  min-width:504px;
  max-width:840px;
  margin: 0 auto;
  background-color: $gray-3;
}

.editor{
  display: block;
  margin: 0 auto;
}

.main-area {
  width: 100%;
  margin: 80px auto 0 auto;
  background-color: $gray-3;
  border: $gray-3 solid 1px;
  text-align: center;
}

.canvas-area {
  display: inline-block;
}

.canvas-container{
    margin-top:2em;
    width: auto;
  }

@media only screen and (min-width: 700px) {
  .main-area {
    height: 100vh;
  }
}

@media only screen and (max-width: 768px) {
  .editor-wrapper{
    display:block;
    width:504px
  }
  .outside-container{
    width:100%;
    margin: 0 auto;
 }
}


.thumbnail-wrapper{
  display:flex;
  height: 120px; /*check height */
  width:100%;
  background-color: $gray-3;
  justify-content: space-between;
  margin: 2em auto;
  padding: 0 2px;
}

.thumbnail {
  border:none;
}

.thumbnail.active {
   border:get-theme-color('accent','thumbnail') 1px solid;
}

.hide {
  display: none;
}

@media only screen and (max-width: 550px) {
  .editor-wrapper{
    display:flex;
    width: 100%;
    min-width: 0;
    // max-width:840px;
    margin: 0 auto;
}
  .main-area {
    transform-origin: 0 0;
    transform: scale(0.7,0.7);
    margin: 70px auto 0 auto;
}
  .canvas-container{
    margin-top:0;
    // border:get-theme-color('accent','thumbnail') 1px solid;
  }
}

</style>

<style scoped lang="scss">
  @import '~bootstrap/scss/_functions';
  @import '~bootstrap/scss/_variables';
  @import '~bootstrap/scss/mixins/_breakpoints';
  @import '~scss/colors';

  :host {
    .hidden {
      visibility: hidden;
    }

    .editor-content {
      padding-top: 30px;
    }

    .editor-wrapper {
      position: relative;
      width: 90%;
      height: 100%;
      margin: 0 auto;

      @include media-breakpoint-up(sm) {
      }

      @include media-breakpoint-only(xs) {
      }

      .debug-wrapper {
        margin: 0;
        padding: 0;
        height: 0;

        .debug {
          width: 100%;
          padding: 1rem;
        }
      }
    }

    .content-wrapper {
      margin: 105px auto 0 auto;
      padding-top: 50px;
      min-height: 600px;

      &.missing-fonts {
        margin: 0 auto;
      }

      .loader {

      }

      .design {
        padding-left: 0;
      }
    }
  }

  .missing-fonts-wrapper {
    background: $white;
    width: 100%;
    height: 100%;
    padding: 2rem;
  }

  .missing-fonts-superuser {
    margin: 105px auto 0 auto;
    padding-top: 2rem;
  }

  .editor-alert {
    max-width: 504px;
    font-size: small;
  }
</style>
<script>
import {fabric} from 'fabric'
import {mapActions, mapGetters} from 'vuex'
import Scaler from '@/lib/Scaler'
import ToolBar from './ToolBar'
import SideMenu from './SideMenu'
import FixedMenu from './FixedMenu'
import EditorCanvas from './EditorCanvas'
import EditorFonts from './EditorFonts'
import EditorThumbnail from './EditorThumbnail'
import EditorBackPlaceholder from './EditorBackPlaceholder'
import ImageUploadDropzone from './ImageUploadDropzone'
import FieldOptionsArea from './FieldOptionsArea'
import Vue from 'vue';

export default {
  data() {
    return {
      loaded: false,
      fontsLoaded: false,
      from: null,
      nofill: false,
      unlock: false,

      canvasStates: [{}, {}],
      busses: [new Vue(), new Vue()],
    }
  },
  mounted() {
    let {id, from} = this.$route.params;
    this.from = from;
    this.nofill = this.$route.query.fill === 'no';
    this.unlock = this.$route.query.unlock == 'yes';
    this.setCurrentDesignId(id);
    this.loadSelectedLine({designId: +id});
  },
  computed: {
    ...mapGetters(['design', 'pageNum', 'designPageCount', 'editorMessage', 'flags', 'selectedLine', 'missingFonts', 'isTemplate', 'designOptions']),

    currentCanvasState() {
      return this.canvasStates[this.pageNum];
    },
    currentBus() {
      return this.busses[this.pageNum];
    },

    designLocked() {
      if (this.isTemplate || !this.designOptions || this.unlock) return false;
      return this.designOptions.lockDesign;
    },
    lockButtons() {
      return this.designLocked && !this.isTemplate;
    },
    showThumbnails() {
      return (this.designPageCount > 1) || !this.designLocked;
    },
    actionParams() {
      // Return an object describing how the "next action" should be presented.
      if (this.isTemplate) {
        return {
          variant: 'primary',
          button: 'Set Template',
          help: "When your card looks perfect, save your team's template.",
          action: 'setDesignAsTemplate',
          next: `/dashboard/${this.from||'design'}`
        }
      } else if (this.from) {
        // Approval uses this
        return {
          variant: 'primary',
          button: 'Continue',
          help: "When your card looks perfect, continue below.",
          next: `/dashboard/${this.from}`
        }
      } else if (this.selectedLine) {
        return {
          variant: 'action',
          button: 'Checkout',
          help: "When your card looks perfect, continue checking out.",
          action: 'checkout',
          next: '/cart'
        }
      } else {
        // Continue to catalog to choose a card
        return {
          variant: 'action',
          button: 'Choose Card',
          help: "When your card looks perfect, continue checking out.",
          action: 'checkout',
          next: {name: 'Catalog', query: {design: this.design.id}}
        }
      }
    }
  },
  methods: {
    ...mapActions(['setCurrentDesignId', 'showEditorMessage', 'loadSelectedLine', 'setDesignAsTemplate', 'invalidateDesign']),
    onFontsLoaded() {
      this.fontsLoaded = true;
    },
    onFontLoadError(e) {
      // TODO: display error
      console.error(e);
      this.fontsLoaded = true;
    },
    onDropFail({droppedType,allowedTypes,allowedText}) {
      console.log('drop fail', droppedType, allowedTypes, allowedText);
      this.showEditorMessage('Unable to handle dropped file type. Please upload '+(allowedText|| ' valid file'));
    },
    onCanvasState({canvasState, pageNum}) {
      this.canvasStates.splice(pageNum, 1, canvasState);
    },
    testMessage() {
      this.showEditorMessage('test');
    },
    clearMessage() {
      this.showEditorMessage('');
    },
    async onAction() {
      if (this.currentBus) {
        this.currentBus.$emit('exit');
      }
      let {action} = this.actionParams;
      if (action) await this[action]();
      this.$router.push(this.actionParams.next);
    },
    checkout() {
      // This is the only action we need to perform.
      // By invalidating the design, we avoid issues
      // where later editing doesn't re-load the design correctly.
      return this.invalidateDesign();
    }
  },
  components: {
    ToolBar,
    SideMenu,
    FixedMenu,
    EditorCanvas,
    EditorFonts,
    EditorThumbnail,
    EditorBackPlaceholder,
    ImageUploadDropzone,
    FieldOptionsArea
  }
}


</script>



// WEBPACK FOOTER //
// src/components/pages/editor/Editor.vue